module.exports = __webpack_public_path__ + "3ac99865425c5f0ca6fadda8775a1d69.png";